import {Component, Input, OnInit} from '@angular/core';
import {ProfileService} from '../../../../services/profile.service';
import {Profile} from '../../../../model/profile';
import {Observable} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {CommonModule} from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {SpinnerComponent} from "../../../common/spinner/spinner.component";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {CopyDirective} from "../../../../directives/copy.directive";

@Component({
    selector: 'app-dash-block-commercial',
    templateUrl: './dash-block-commercial.component.html',
    imports: [
        CommonModule,
        FaIconComponent,
        SpinnerComponent,
        NgbTooltip,
        CopyDirective,
    ],
    styleUrls: ['./dash-block-commercial.component.css']
})
export class DashBlockCommercialComponent implements OnInit {

  @Input()
  showTooltip = false;
  profile: Observable<Profile>;

  constructor(private profileService: ProfileService, private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.profile = this.profileService.getProfile();
  }

}
